import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
export function passwordSignUpValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;
    if (!password) return null;

    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+=\[\]{};':"\\|,.<>\/?]/.test(password);
    const isValidLength = password.length >= 8;

    const valid = hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar && isValidLength;

    if (valid) return null;

    return {
      passwordInvalid: true,
      missingUpperCase: !hasUpperCase,
      missingLowerCase: !hasLowerCase,
      missingNumber: !hasNumber,
      missingSpecialChar: !hasSpecialChar,
      tooShort: !isValidLength
    };
  };
}

